import React from "react"
import game from "treasure-island.png"

const TreasureIsland = props => <img src={game} className="game" {...props} />

export default TreasureIsland
